import {toggleQuickBookSettings} from 'helpers';
import {portalActionTypes} from 'actions/actionTypes';

const initialState = {
  addOns: [],
  dictionary: null,
  loadingDictionary: true,
  loadingPortalSettings: true,
  portalInfo: {},
  portalSettings: {},
};

export default function portal(state = initialState, action) {
  switch (action.type) {
    case portalActionTypes.LOAD_ADDON_SUCCESS:
      return {...state, addOns: action.addOns};

    case portalActionTypes.UPDATE_ADDON_SUCCESS: {
      const addOns = [...state.addOns];
      const index = addOns.findIndex(s => s.name === action.setting.name);

      if (index !== -1) {
        if (action.setting.name.indexOf('QB') > -1) {
          toggleQuickBookSettings(addOns, action.setting);
        }

        const setting = {...addOns[index]};

        setting.value = action.setting.value;
        addOns[index] = setting;
      }

      return {...state, addOns};
    }

    case portalActionTypes.LOAD_PORTAL_SUCCESS:
      return {
        ...state,
        loadingPortalSettings: false,
        portalInfo: action.portalData,
      };

    case portalActionTypes.LOAD_PORTAL_SETTINGS_SUCCESS:
      return {...state, portalSettings: action.portalSettings};

    case portalActionTypes.LOAD_PORTAL_SETTINGS_COMPLETE:
      return {...state, loadingPortalSettings: false};

    case portalActionTypes.LOAD_PORTAL_SETTINGS_COMPLETE:
      return {...state, loadingPortalSettings: false};

    case portalActionTypes.LOAD_DICTIONARY_SUCCESS:
      return {
        ...state,
        dictionary: action.dictionary,
        loadingDictionary: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/portalReducer.js